import { render } from "./loading-shimmer.vue?vue&type=template&id=f821471e&scoped=true&lang=pug"
import script from "./loading-shimmer.vue?vue&type=script&lang=js"
export * from "./loading-shimmer.vue?vue&type=script&lang=js"

import "./loading-shimmer.vue?vue&type=style&index=0&id=f821471e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f821471e"]])

export default __exports__